import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import axios from 'axios';

import getMetaTagData from '../../src/common/services/getMetaTagData';
import TvTopMenu from '../../src/component/pc/tv/TopMenu';
import Theme from '../../src/component/pc/tv/Theme';
import Box from '../../src/component/pc/common/Box';
import Loading from '../../src/component/pc/common/Loading';

import { getSectionDataApiUrl } from '../../src/common/utils/tvUtil';
import { SECTION_LIST_PAGE_LIMIT } from '../../src/common/constants/number';
import { toFit } from '../../src/hooks/useToFit';

function Home ({ defaultMetaTagData }) {
  const [sortHTxt, setSortHTxt] = useState('');
  const router = useRouter();
  const { pageSection: section, category = '', sort = '' } = router.query;

  const [pageSection, setPageSection] = useState(section);
  const [metaTagData, setMetaTagData] = useState(defaultMetaTagData);
  const [pageQueryParams, setPageQueryParams] = useState({ section, category, sort, offset: 0, limit: SECTION_LIST_PAGE_LIMIT });
  const [sectionDataList, setSectionDataList] = useState([]);
  const [sectionDataIsLoading, setSectionDataIsLoading] = useState(false);

  function sortCodeTxt (code) {
    let result;
    try {
      if (code === 'new') {
        result = '최신';
      } else if (code === 'top') {
        result = '인기';
      } else if (code === 'abc') {
        result = '가나다';
      } else if (code === 'theme') {
        result = '추천';
      } else if (code === 'all') {
        result = '전체';
      } else if (code === 'N') {
        result = '방영 예정';
      } else if (code === 'Y') {
        result = '방영 중';
      } else {
        result = '';
      }
    } catch (error) {
      result = '';
    }

    return result;
  }

  function onPageQueryParamsChanged ({ sectinoCode = '', categoryCode = '', sortCode = '' }) {
    setSortHTxt(sortCodeTxt(sortCode));
    pageQueryParams.section = sectinoCode;
    pageQueryParams.category = categoryCode;
    pageQueryParams.sort = sortCode;
    pageQueryParams.offset = 0;

    setPageQueryParams({ ...pageQueryParams });
    setPageSection(sectinoCode);
  }

  useEffect(() => {
    window.document.addEventListener('scroll', toFit(doNextPage, {}));

    function doNextPage () {
      if ((window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight) {
        setPageQueryParams(prev => {
          const nextOffset = prev.offset + prev.limit;
          let sectionDataListLength;
          setSectionDataList(sPrev => {
            sectionDataListLength = sPrev.length;
            return sPrev;
          });

          if (sectionDataListLength === nextOffset) {
            prev.offset = nextOffset;
            return { ...prev };
          } else {
            return prev;
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    const sectionDataApiUrl = getSectionDataApiUrl(pageQueryParams.offset, pageQueryParams.sort, pageQueryParams.section, pageQueryParams.category);
    const config = {
      method: 'get',
      url: sectionDataApiUrl.href,
      timeout: 3000
    };

    setSectionDataIsLoading(true);

    axios(config)
      .then(function (response) { // TODO: theme 에서 contents 있어야하는 부분
        const addList = [];
        let clickParamsCategory = pageQueryParams.category;
        if (clickParamsCategory === null || clickParamsCategory === '') {
          clickParamsCategory = 'total';
        }
        const clickParamsSort = pageQueryParams.sort;
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          const item = {
            type: 'poster',
            img: element.pgm_img_url,
            info: { title: element.pgm_nm },
            label: [],
            link: element.link_url,
            isNew: element.new_yn === 'Y',
            contents: element.contents,
            data: { pgm_nm: element.pgm_nm },
            isfree: element.free_part_yn,
            link_new_yn: element.link_new_yn,
            clickParams: 'div=tv_' + clickParamsCategory + '_' + clickParamsSort
          };
          addList.push(item);
        }

        const currentOffset = Number.parseInt(sectionDataApiUrl.searchParams.get('offset')) || 0;

        if (currentOffset === 0) {
          if (addList.length > 0) {
            setSectionDataList(addList); // 최종적으로 통신에서 불러온 데이터를 list 에서 담는 부분
          } else {
            setSectionDataList([]);
          }
        } else {
          setSectionDataList(prev => ([...prev, ...addList]));
        }
      })
      .catch(function (error) {
        //console.log(error);
      })
      .finally(() => {
        setSectionDataIsLoading(false);
      });
  }, [pageQueryParams]);

  useEffect(async () => {
    const curentaTagData = getMetaTagData(router.asPath, pageSection, category);

    setMetaTagData(curentaTagData);
  }, [pageSection]);

  // 주소에 따라서 theme 일때 theme 컴포넌트화해서 분기 호출
  if (pageQueryParams.sort === 'theme') {
    return (
      // TODO: `contents` css class를 빼는것이 맞는지 확인 필요
      <div className='contents'>
        {/* <div id='container'> */}
        <Head>
          <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
          <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
          <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />

          <meta name='description' content={metaTagData.shareDescription} />
          <meta name='keywords' content={metaTagData.keywords} />
          <meta name='twitter:card' content='summary' />
          <noscript>Your browser does not support JavaScript!</noscript>
          <meta property='og:type' content='website' />
          <meta property='og:locale' content='ko_KR' />
          <meta property='og:site_name' content='SBS' />
          <meta property='og:title' content={metaTagData.shareTitle || ''} />
          <meta property='og:description' content={metaTagData.shareDescription || ''} />
          <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
          <meta property='og:url' content={metaTagData.currentUrl || ''} />
          <meta name='nate:site_name' content='SBS' />
          <meta name='nate:title' content={metaTagData.shareTitle || ''} />
          <meta name='nate:description' content={metaTagData.shareDescription || ''} />
          <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
          <meta name='nate:url' content={metaTagData.currentUrl || ''} />
          <title>{metaTagData.shareTitle}</title>
        </Head>
        <div role='main' id='container' className='tv_listcontents_wrap'>{/* 페이지 명 클래스  */}
          <TvTopMenu sectionCode={section} categoryCode={category} sortCode={sort} onChange={onPageQueryParamsChanged} />
          <h3 className='hide'>{sortHTxt}</h3>
          <Theme />

        </div>
      </div>
    );
  } else {
    return (
    // TODO: `contents` css class를 빼는것이 맞는지 확인 필요
      <div className='contents'>
        {/* <div id='container'> */}
        <Head>
          <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
          <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
          <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />

          <meta name='description' content={metaTagData.shareDescription} />
          <meta name='keywords' content={metaTagData.keywords} />
          <meta name='twitter:card' content='summary' />
          <noscript>Your browser does not support JavaScript!</noscript>
          <meta property='og:type' content='website' />
          <meta property='og:locale' content='ko_KR' />
          <meta property='og:site_name' content='SBS' />
          <meta property='og:title' content={metaTagData.shareTitle || ''} />
          <meta property='og:description' content={metaTagData.shareDescription || ''} />
          <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
          <meta property='og:url' content={metaTagData.currentUrl || ''} />
          <meta name='nate:site_name' content='SBS' />
          <meta name='nate:title' content={metaTagData.shareTitle || ''} />
          <meta name='nate:description' content={metaTagData.shareDescription || ''} />
          <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
          <meta name='nate:url' content={metaTagData.currentUrl || ''} />
          <title>{metaTagData.shareTitle}</title>
        </Head>
        <div role='main' id='container' className='tv_listcontents_wrap'>{/* 페이지 명 클래스  */}
          <TvTopMenu sectionCode={section} categoryCode={category} sortCode={sort} onChange={onPageQueryParamsChanged} />

          {/* 기본 정렬 */}
          <div className='contents_area_tvlist'>
            <div className='tv_list_w'>
              {/* <!-- sorgint_btn_cont 에 current 된 탭 이름 타이틀로 제공 --> */}
              <h3 className='hide'>{sortHTxt}</h3>
              <ul className='tv_list_inner'>

                {sectionDataList.map((item, index) => {
                  return (
                    <li key={index} className='tv_list_cont'>
                      <Box view {...item} />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {sectionDataIsLoading && <Loading />}

        </div>

      </div>
    );
  }
}

export async function getServerSideProps (ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const defaultMetaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  const tvSectionTopList = await getTvSectionTopList(pageSection, pageCategory);

  if (Array.isArray(tvSectionTopList?.data) && tvSectionTopList.data.length > 0) {
    const topProgramTitleList = tvSectionTopList.data.map(item => item.pgm_nm);
    if (defaultMetaTagData.keywords) {
      defaultMetaTagData.keywords = defaultMetaTagData.keywords + ',' + topProgramTitleList.toString();
    } else {
      defaultMetaTagData.keywords = topProgramTitleList.toString();
    }
  }

  return { props: { defaultMetaTagData } };
}

async function getTvSectionTopList (sectionCode, categoryCode) {
  const sectionDataApiUrl = getSectionDataApiUrl(0, 'top', sectionCode, categoryCode, 20);
  const config = {
    method: 'get',
    url: sectionDataApiUrl.href,
    timeout: 3000
  };

  return axios(config)
    .catch(function (error) {
      //console.log(error);
    });
}

export default Home;
